import { SignInResponse } from "next-auth/react";

export function isSignInResponseOk(response: SignInResponse): boolean {
    return response.ok === true && response.status === 200;
}
